import { PureComponent } from "react";
import VideosCarouselDesktopComponent from "./desktop/videos-carousel-desktop-component";

export default class VideosCarouselComponent extends PureComponent {
  render() {
    return (
      <div className="videos-carousel-container">
        <div className="videos-carousel-desktop-wrapper">
          <VideosCarouselDesktopComponent {...this.props} />
        </div>
      </div>
    );
  }
}

VideosCarouselComponent.defaultProps = {
  title: "A new way to manage your <brand-purple>workflow.</end>",
  videos: [
    {
      title: "Nate Travers <brand-blue>Manufactoring</end>",
      videoId: "1UbaEcto56k",
      poster: "/static/img/templates/long-template/segments/boards/board-with-cactus-and-phone.png"
    },
    {
      title: "Aleah Jean Rosales <brand-green>Creative</end>",
      videoId: "1UbaEcto56k",
      poster: "/static/img/templates/long-template/segments/boards/board-with-timeline-and-cactus.png"
    },
    {
      title: "Brad Wohlgemuth <brand-pink>Broadcast</end>",
      videoId: "1UbaEcto56k",
      poster: "/static/img/templates/long-template/segments/boards/board-with-pencils.png"
    }
  ]
};
